import { useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { wacToken } from "@/libraries/design/foundations";
import {
    StatsModuleProps,
    Stats
} from "@/libraries/design/patterns/stats/src/stats";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const StatsSection = () => {
    const gwp7518NavIconUpdates = checkFeatureFlagGate(
        featureFlags.gwp7518NavIconUpdates
    );
    const intl = useIntl();

    const statsProps: StatsModuleProps = {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.stats.header",
            defaultMessage: "High-performing enterprises run on Atlassian"
        }),
        bigStat: {
            stat: "200",
            statText: intl.formatMessage({
                id: "EnterpriseLandingPage.stats.bigText",
                defaultMessage:
                    "countries around the world where Atlassian software helps power enterprise"
            }),
            statColor: wacToken("color.primary.blue"),
            statSymbol: {
                symbolCharacter: "+",
                symbolCharacterColor: wacToken("color.primary.blue")
            }
        },
        littleStats: [
            {
                stat: "44",
                statText: intl.formatMessage({
                    id: "EnterpriseLandingPage.stats.littleText1",
                    defaultMessage:
                        "of enterprise customers are able to make faster data-driven decisions after moving to the cloud"
                }),
                statColor: wacToken("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "%",
                    symbolCharacterColor: wacToken("color.primary.blue")
                }
            },
            {
                stat: "79",
                statText: gwp7518NavIconUpdates
                    ? intl.formatMessage({
                          id: "EnterpriseLandingPage.stats.littleText2-gwp-7518",
                          defaultMessage:
                              "of enterprise customers are satisfied with Atlassian cloud apps"
                      })
                    : intl.formatMessage({
                          id: "EnterpriseLandingPage.stats.littleText2",
                          defaultMessage:
                              "of enterprise customers are satisfied with Atlassian cloud products"
                      }),
                statColor: wacToken("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "%",
                    symbolCharacterColor: wacToken("color.primary.blue")
                }
            }
        ]
    };

    return (
        <UFOSegment name="enterprise-page-stats">
            <section>
                <Stats {...statsProps} />
            </section>
        </UFOSegment>
    );
};
